module.exports = __webpack_public_path__ + "img/03_vedio3.e7f8fdb2.png";